// iframe

// vendor
//=require ../vendors/iframeResizer.js

(function($) {
    $('.gr-autoHeight').iFrameResize();
})(window.rossel.jquery);
